import { ActionType, createReducer } from 'typesafe-actions';
import { FETCH_RELATED_PRODUCTS, RESET_RELATED_PRODUCTS } from './actions';
import { RelatedProducts } from './types';

type RelatedProductsActions =
  | ActionType<typeof FETCH_RELATED_PRODUCTS.failure>
  | ActionType<typeof FETCH_RELATED_PRODUCTS.cancel>
  | ActionType<typeof FETCH_RELATED_PRODUCTS.success>
  | ActionType<typeof RESET_RELATED_PRODUCTS>;
export const relatedProducts = createReducer<RelatedProducts | null, RelatedProductsActions>(null)
  .handleAction(
    [FETCH_RELATED_PRODUCTS.failure, FETCH_RELATED_PRODUCTS.cancel, RESET_RELATED_PRODUCTS],
    () => null,
  )
  .handleAction(FETCH_RELATED_PRODUCTS.success, (_, { payload }) => payload);
